import React, { useEffect } from 'react';
import { change as changeAction, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { DataListModel } from '@app/src/common/PredictiveInput/DataListModel';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import * as validate from '@app/src/utils/validations';
import { renderInput } from '@app/src/common/Input';
import { fetchDistrictAction, setDistrictFullData, clearDistrictFullData } from '@app/src/views/StepOne/form';
import { renderPredictive } from '@app/src/common/PredictiveInput';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  propertyId: number;
}

export const TitleDistrict: React.FC<Props> = ({ propertyId }) => {
  const dispatch = useDispatch();
  const currentUbigeo = useSelector(state => state.district.ubigeo);
  const properties: SelectItemModel[] = useSelector(state => state.typeProperty.data);
  const propertiesAlias = ['decoracion', 'decoracion-electro', 'hogar', 'alfombra', 'banca-finanzas'];
  const propertyMatch = properties.filter(property => property &&  property.data && property.data.id === propertyId)[0];
  const isTitleInput = propertiesAlias.includes(propertyMatch && propertyMatch.data.alias);
  const print = useSelector(state => state.print.general);
  const currentTitle = useSelector(state => state.form.stepOne.values.title);

  useEffect(() => {
    if (print && print.title) {
      dispatch(changeAction('stepOne', 'title', print.title));
      if (print.ubigeo) {
        dispatch(setDistrictFullData(print.ubigeo));
        dispatch(changeAction('stepOne', 'districtName', print.districtName));
      }
    }
    if (!isTitleInput) {
      if (isClient && window.innerWidth < 768) {
        dispatch(fetchDistrictAction('lim'));
      }
    }
  }, []);

  useEffect(() => {
    if (print.property !== propertyId) {
      dispatch(clearDistrictFullData());
      dispatch(changeAction('stepOne', 'title', ''));
      dispatch(changeAction('stepOne', 'districtName', ''));
    }
  }, [propertyId]);

  const handleChangePredictive = (data: DataListModel) => {
    if (data && data.data) {
      const { location, location_name } = data.data;
      dispatch(setDistrictFullData(location));
      dispatch(changeAction('stepOne', 'title', location_name));
      dispatch(changeAction('stepOne', 'districtName', location_name));
    }
  };

  const handleBlurPredictive = () => {
    if (!currentUbigeo) {
      dispatch(changeAction('stepOne', 'title', ''));
      dispatch(changeAction('stepOne', 'districtName', ''));
    }
  };

  const handleClickClose = () => {
    dispatch(changeAction('stepOne', 'title', ''));
    dispatch(changeAction('stepOne', 'districtName', ''));
    dispatch(clearDistrictFullData());
  }

  return isTitleInput ?
  (
    <FieldForm label="Título de la publicación">
      <Field
        name="title"
        placeholder="Ej. Decoración"
        maxLength={50}
        component={renderInput}
        validate={[validate.required, validate.minLength3]}
        defaultValue={currentTitle}
      />
    </FieldForm>
  ) :
  (
    <FieldForm label="Distrito">
      <Field
        name="title"
        defaultUbigeo={currentUbigeo}
        handleChange={handleChangePredictive}
        handleBlur={handleBlurPredictive}
        component={renderPredictive}
        validate={[validate.required]}
        handleClickClose={handleClickClose}
        normalize={value => value && value.replace(/\s\s+|\n/g, ' ')}
        onDemand
      />
    </FieldForm>
  )
};
